import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'transformAddress',
})
export class TransformAddressPipe implements PipeTransform {
  transform(value :any) :string {
    const combineStateZipCountry = [
      value?.state ?? value?.business_state,
      value?.postalCode ?? value?.postal_code ?? value?.business_zip,
      value?.country ?? value?.business_country,
    ]
      .filter(Boolean)
      .join(' ');

    return [
      value?.address ?? value?.business_address,
      value?.addressLine2 ??
        value?.address_line_2 ??
        value?.business_address_line_2,
      value?.city ?? value?.business_city,
      combineStateZipCountry,
    ]
      .filter(Boolean)
      .join(', ');
  }
}
